import React from "react";
import { RateContainer } from "./styled";

interface RateProps {
  stars: JSX.Element[];
  style?: {};
}

const Rate = ({ stars, style }: RateProps) => {
  return <RateContainer style={style}>{stars}</RateContainer>;
};

export default Rate;
